import {
  DisclosureGroup as AriaDisclosureGroup,
  type DisclosureGroupProps as AriaDisclosureGroupProps,
} from 'react-aria-components';

export type AccordionGroupProps = AriaDisclosureGroupProps;

export function AccordionGroup({ children, ...props }: AccordionGroupProps): React.ReactNode {
  return <AriaDisclosureGroup {...props}>{children}</AriaDisclosureGroup>;
}
